import { makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import helpers from 'helpers'

const styles = (isCompact) =>
  makeStyles((theme) => {
    const { watch } = useFormContext()
    const { fontFamily, secondaryColor } =
      helpers.cookies.banner.getStyleTokens(watch)

    return {
      globalTypography: {
        fontSize: isCompact ? 12 : 14,
        fontFamily: fontFamily,
        fontWeight: 400,
        width: 'fit-content',
        color: secondaryColor,
      },
      seeMoreLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.25),
        whiteSpace: 'nowrap',
        padding: 0,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        fontFamily: fontFamily,
        fontSize: 13,
        fontWeight: 600,
        color: secondaryColor,
      },
      seeMoreIcon: {
        width: isCompact ? 14 : 16,
        height: isCompact ? 14 : 16,
      },
    }
  })

export default styles
